import { joinLiveRoom } from "@saas/components";
import { isRichMediaLessonType } from "@saas/components/src/utils/lesson-type";
import { jsToFlutter } from "@saas/components/src/utils/js-to-flutter";
import { getUserToken } from "@saas/service-api/src/live-list";
import { checkLesson } from "@saas/service-api/src/learning-center";
import { isH5, isHXApp, compareVersion } from "@saas/components/src";
import { handleDuration } from "@saas/components/src/utils/utils";
import { getLessonTypeConfig } from "@saas/components/src/utils/lesson-type";
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  props: {
    unitList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isRegistered: {
      type: Boolean,
      default: false, //是否已报名
    },
  },
  data: function () {
    return {
      activeNames: [],
      moment,
      handleDuration,
      isH5: isH5(),
      isHXApp: isHXApp(),
      loading: null,
      isElectron: window.isElectron,
    };
  },
  created() {
    if (window.isElectron) {
      // window.ipcRenderer.on("join-live-room-over", this.stopLoading);
    } else {
      window.addEventListener("join-live-room-over", this.stopLoading, true);
    }
  },
  beforeDestroy() {
    window.removeEventListener("join-live-room-over", this.stopLoading, true);
    // window?.ipcRenderer?.removeListener(
    //   "join-live-room-over",
    //   this.stopLoading
    // );
  },
  methods: {
    // 跳转视频播放页
    jumpVideoPlay(lesson) {
      let { course_id, lesson_id, unit_id, id } = lesson;
      let lessonId = lesson_id || id;
      this.$router.push({
        path: `/video-play/${course_id}/${unit_id}/${lessonId}`,
      });
    },
    stopLoading() {
      this.loading && this.loading.close();
    },
    goHomeWorkPage(workInfo) {
      if (!this.isRegistered) {
        this.$showToast("未报名");
      } else if (this.isRegistered) {
        let { id, answer_type } = workInfo;
        if (answer_type === 1) {
          this.$router.push(`/homework/${id}`);
        } else if (answer_type === 2) {
          this.$router.push(`/homework-custom/${id}`);
        }
      }
    },
    handleUnsupportedLesson(lesson) {
      const lessonTypeConfig = getLessonTypeConfig(lesson.lesson_type);
      this.$showToast(`${lessonTypeConfig.label}暂不支持，请升级客户端后再试`);
    },
    goReplay(lesson) {
      if (this.isAuthenticated) {
        if (!this.isRegistered && !lesson.canTrial) {
          // 未报名且不可试学
          this.$showToast("未报名");
        } else {
          // 已报名 || 可试学
          let { course_id, unit_id, id } = lesson;
          if (this.isRegistered) {
            // 已报名
            if (window.isElectron) {
              this.$router.push({
                path: `/video-play/${course_id}/${unit_id}/${id}`,
              });
              // window.open(
              //   `${process.env.VUE_APP_SAAS_WEB_URL}/replay/${course_id}/${unit_id}/${id}`,
              //   "_blank",
              //   `page=replay&refreshToken=${getRefreshToken()}&token=${getToken()}`
              // );
            } else if (this.isHXApp) {
              this.goAppVideoPlayer(lesson);
            } else {
              // this.$router.push({
              //   path: `/replay/${course_id}/${unit_id}/${id}`,
              // });
              this.$router.push({
                path: `/video-play/${course_id}/${unit_id}/${id}`,
              });
            }
          } else if (lesson.canTrial) {
            // 可试学
            checkLesson({ course_id: course_id, lesson_id: id }).then((res) => {
              if (res.code === 1) {
                if (window.isElectron) {
                  this.$router.push({
                    path: `/video-play/${course_id}/${unit_id}/${id}`,
                  });
                  // window.open(
                  //   `${process.env.VUE_APP_SAAS_WEB_URL}/replay/${course_id}/${unit_id}/${id}?trial=1`,
                  //   "_blank",
                  //   `page=replay&refreshToken=${getRefreshToken()}&token=${getToken()}`
                  // );
                } else if (this.isHXApp) {
                  this.goAppVideoPlayer(lesson);
                } else {
                  this.$router.push({
                    path: `/video-play/${course_id}/${unit_id}/${id}`,
                  });
                  // this.$router.push({
                  //   path: `/replay/${course_id}/${unit_id}/${id}?trial=1`,
                  // });
                }
              } else {
                this.$message.error(res.message);
              }
            });
          }
        }
      } else {
        this.jumpLoginPage();
      }
    },
    goAppVideoPlayer(lesson) {
      let { course_id, unit_id, id } = lesson;
      // 图文课没有原生播放器：留在 WebView 里进阅读器，不能交给 App 的 videoPlayer 桥
      if (isRichMediaLessonType(lesson.lesson_type)) {
        this.$router.push({ path: `/video-play/${course_id}/${unit_id}/${id}` });
        return;
      }
      let params = {
        course_id,
        unit_id,
        lesson_id: id,
      };
      jsToFlutter("videoPlayer", params);
    },
    handleLiveClick(lesson) {
      if (this.isAuthenticated) {
        if (!this.isRegistered && !lesson.canTrial) {
          // 未报名且不可试学
          this.$showToast("未报名");
        } else {
          // 已报名 || 可试学
          // if (lesson.roomStatus === 1) {
          //   this.$showToast("未开始");
          // } else if (lesson.liveStatus === 2) {
          //   this.$showToast("回放生成中");
          // } else
          if (lesson.liveStatus === 1) {
            this.goReplay(lesson);
          } else {
            if (this.isHXApp) {
              if (compareVersion("1.10.0") === -1) {
                // 兼容老版本
                if (lesson.roomStatus === 1) {
                  this.$showToast("未开始");
                } else if (lesson.liveStatus === 2) {
                  this.$showToast("回放生成中");
                } else if (lesson.liveStatus === 3) {
                  this.goLiveRoom(lesson);
                }
              } else {
                this.goAppVideoPlayer(lesson);
              }
            } else {
              this.$router.push({
                path: `/video-play/${lesson.course_id}/${lesson.unit_id}/${lesson.id}`,
              });
            }

            // this.goLiveRoom(lesson);
          }
        }
      } else {
        // 未登录
        this.jumpLoginPage();
      }
    },
    // 进入教室
    goLiveRoom(obj) {
      let params = {
        course_id: obj.course_id,
        lesson_id: obj.id,
      };
      if (this.isAuthenticated) {
        // 登录
        this.loading = this.$loading({
          lock: true,
          text: "进入教室中",
          spinner: "el-icon-loading",
          background: "rgba(255,255,255,.6)",
          fullscreen: true,
        });
        getUserToken(params).then((res) => {
          if (res.code === 1) {
            let {
              room_id = "",
              token = "",
              user_id = "",
              is_lesson_teacher,
              is_lesson_assistant,
              risk_control_switch,
              risk_control_config = {},
            } = res.data;
            let { course_id = "", id = "" } = obj;
            const disableRecord =
              risk_control_switch === 1 &&
                risk_control_config.recording_screen_switch === 1
                ? 1
                : 0;
            if (this.isHXApp) {
              let params = {
                room_id,
                user_id,
                course_id,
                lesson_id: id,
                token,
                disableRecord,
              };
              jsToFlutter("joinLiveRoom", params);
              this.stopLoading();
            } else {
              joinLiveRoom({
                classid: room_id,
                userid: user_id,
                courseid: course_id,
                lessonid: id,
                token: token,
                disableRecord,
                isTeacher: is_lesson_teacher,
                isAssistant: is_lesson_assistant,
                mode: obj.mode,
                isNewLive: obj.is_new_live,
              });
            }
          } else if (res.code === 40007) {
            // 开启网页防火墙
            this.$router.replace("/firewall/" + obj.course_id);
            this.stopLoading();
          } else {
            this.$message.error(res.message);
            this.stopLoading();
          }
        });
      } else {
        // 未登录
        this.jumpLoginPage();
      }
    },
    jumpLoginPage() {
      if (this.isHXApp) {
        jsToFlutter("login");
        console.log("jsToFlutter===login-lessonlist");
      } else {
        // let preRoute = window.location.href;
        // window.location.href = `${process.env.VUE_APP_ADMIN_URL}/login?return_url=${preRoute}`;
        this.$loginDialog();
      }
    },
  },
  computed: {
    ...mapGetters(["isAuthenticated"]),
    showLock() {
      return (lesson) => {
        // 可试学
        if (lesson.canTrial) {
          return false;
        }
        // 未登录
        if (!this.isAuthenticated) {
          return true;
        }
        // 已报名
        if (this.isRegistered) {
          return false;
        } else {
          return true;
        }
      };
    },
  },
  watch: {
    unitList: {
      handler: function (newVal) {
        if (!newVal.length) return;
        // 默认展开第一项
        let firstId = newVal[0]?.id;
        if (firstId) {
          this.activeNames = [firstId];
        }
      },
      immediate: true, // 设置为true，以便在初次渲染时执行handler
    },
  },
};
